import { render } from "./B2bPageFacturas.vue?vue&type=template&id=5e32f1ce&scoped=true&lang=pug"
import script from "./B2bPageFacturas.vue?vue&type=script&lang=js"
export * from "./B2bPageFacturas.vue?vue&type=script&lang=js"

import "./B2bPageFacturas.vue?vue&type=style&index=0&id=5e32f1ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e32f1ce"]])

export default __exports__